

export default function useAnalytics() {

    const EventTypes = {
        Clicked: "CLICKED",
        AddToTrolley: "ADDTOTROLLEY",
        RemoveFromTrolley: 'REMOVEFROMTROLLEY',
        QuantityMinusClick: 'QTY_MINUS_CLICK',
        QuantityPlusClick: 'QTY_PLUS_CLICK',
        VideoPlay: 'VIDEOPLAY',
        AddToListClick: 'ADD_TO_LIST_CLICK',
        SlidesScrolledRight: 'SLIDES_SCROLLED_RIGHT',
        SlidesScrolledLeft: 'SLIDES_SCROLLED_LEFT'
    };

    const trackCampaignClick = (campaign) => {

        var campaignid = campaign?.uniqueId;

        if (!campaignid) return;

        const payload = {
            Referer: window.location.pathname + window.location.search,
            CampaignId: campaignid,
            EventType: EventTypes.Clicked
        };

        const headers = {
            type: 'application/json',
        };
        const blob = new Blob([JSON.stringify(payload)], headers);

        navigator.sendBeacon('/api/booker/analytics/trackclick', blob);
    };

    const trackEvent = (campaign, eventType, productCode) => {

        var campaignid = campaign?.uniqueId;

        if (!campaignid) return;

        const payload = {
            Referer: window.location.pathname + window.location.search,
            CampaignId: campaignid,
            Type: eventType,
            ProductId: productCode
        };

        const headers = {
            type: 'application/json',
        };
        const blob = new Blob([JSON.stringify(payload)], headers);

        navigator.sendBeacon('/api/booker/analytics/registerevent', blob);
    };


    return {
        EventTypes,
        trackCampaignClick,
        trackEvent
    };
}